var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeefterSvg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 738,
    height: 226,
    viewBox: "0 0 738 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_548)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.461 52.678C104.892 49.4626 98.0306 49.4626 92.4613 52.678L56.5668 73.4017C50.9976 76.617 47.5668 82.5593 47.5668 88.9901V130.438C47.5668 136.868 50.9976 142.811 56.5668 146.026L92.4613 166.75C98.0306 169.965 104.892 169.965 110.461 166.75L146.356 146.026C151.925 142.811 155.356 136.868 155.356 130.438V88.9901C155.356 82.5593 151.925 76.617 146.356 73.4017L110.461 52.678ZM180.805 74.2968C180.805 67.866 177.375 61.9237 171.805 58.7083L110.461 23.2912C104.892 20.0759 98.0305 20.0759 92.4613 23.2912L31.1172 58.7083C25.548 61.9237 22.1172 67.866 22.1172 74.2968V145.131C22.1172 151.562 25.548 157.504 31.1172 160.719L92.4613 196.136C98.0306 199.352 104.892 199.352 110.461 196.136L171.805 160.719C177.375 157.504 180.805 151.562 180.805 145.131V74.2968Z",
    fill: "#A066FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.396 63.7219V154.394H279.772L251.312 97.6618V154.394H234V63.7219H251.375L280.083 121.077V63.7219H297.396Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M364.092 139.324V154.394H324.672V139.324H364.092ZM330.339 63.7219V154.394H312.093V63.7219H330.339ZM358.799 100.464V115.099H324.672V100.464H358.799ZM363.968 63.7219V78.8547H324.672V63.7219H363.968Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M426.741 139.324V154.394H387.321V139.324H426.741ZM392.988 63.7219V154.394H374.741V63.7219H392.988ZM421.448 100.464V115.099H387.321V100.464H421.448ZM426.616 63.7219V78.8547H387.321V63.7219H426.616Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M455.637 63.7219V154.394H437.39V63.7219H455.637ZM484.034 102.27V117.341H451.028V102.27H484.034ZM487.521 63.7219V78.8547H451.028V63.7219H487.521Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M535.535 63.7219V154.394H517.413V63.7219H535.535ZM558.079 63.7219V78.8547H495.306V63.7219H558.079Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M620.665 139.324V154.394H581.245V139.324H620.665ZM586.912 63.7219V154.394H568.666V63.7219H586.912ZM615.372 100.464V115.099H581.245V100.464H615.372ZM620.541 63.7219V78.8547H581.245V63.7219H620.541Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M631.376 63.7219H660.459C666.52 63.7219 671.689 64.7598 675.965 66.8357C680.241 68.9115 683.521 71.9837 685.805 76.0524C688.088 80.121 689.23 85.1445 689.23 91.1229C689.23 96.0219 688.566 100.215 687.237 103.702C685.908 107.148 684.019 110.034 681.57 112.359C679.121 114.642 676.194 116.469 672.789 117.839L667.247 121.139H643.645L643.582 106.007H659.961C662.452 106.007 664.507 105.467 666.126 104.387C667.786 103.267 669.011 101.71 669.8 99.7168C670.63 97.6825 671.046 95.3161 671.046 92.6175C671.046 89.7528 670.672 87.3034 669.925 85.2691C669.219 83.1932 668.077 81.6156 666.499 80.5362C664.963 79.4152 662.95 78.8547 660.459 78.8547H649.623V154.394H631.376V63.7219ZM672.54 154.394L655.913 113.978L675.031 113.916L692.032 153.522V154.394H672.54Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_548",
    x: 0.214167,
    y: 0.579401,
    width: 205.699,
    height: 224.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.60266,
    dy: 3.20532
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.7528
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.482353 0 0 0 0 0.223529 0 0 0 0 0.929412 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_548"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_548",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeefterSvg6);
export default __webpack_public_path__ + "static/media/NeefterSVG6.d1a79651da644e1a8623f8889ed44797.svg";
export { ForwardRef as ReactComponent };